import { get } from 'utils/api';

export const sortList = (value, url, list, setList, data, loadPage, listRef, currentPage) => {
  get({
    url,
    data,
  }).then(res => {
    const { [list]: data } = res;

    setList(data);

    loadPage && loadPage(currentPage);
    listRef && value.page && scrollTop(listRef);
  });
};

function scrollTop(block) {
  if (block.current) {
    const scroll = { top: window.pageYOffset || window.scrollY };
    const blockOffsetTop =
      (window.pageYOffset || document.documentElement.scrollTop) +
      block.current.getBoundingClientRect().top -
      20;

    TweenMax.to(scroll, 0.7, {
      top: blockOffsetTop,
      onUpdate: () => window.scroll(blockOffsetTop, scroll.top),
    });
  }
}

/** Получение списка значений в активном фильтре.
 * @param {object[]} options
 * @returns {any[]}
 */
export const getFilterOptions = options => {
  return options.reduce((acc, item) => {
    if (item.checked) {
      acc.push(item.value);
    }

    return acc;
  }, []);
};

export const updateFilter = (state, name, items) => {
  const sorting = state.sorting || {};
  const workshops = state['workshop-list'].items || [];
  const options = [];

  for (var i = 0; i < items.length; i++) {
    if (items[i].checked) {
      options.push(items[i].value);
    }
  }

  sorting[name] = options;

  const filteredItems = [];

  if (Object.keys(sorting).length) {
    for (var w = 0; w < workshops.length; w++) {
      const workshop = workshops[w];

      if (
        sorting.schools.includes(Number(workshop.sorting.schools)) &&
        sorting.categories.includes(workshop.sorting.categories) &&
        sorting.types.includes(workshop.sorting.types)
      ) {
        filteredItems.push(workshop);
      }
    }
  }

  return { options, items: filteredItems };
};
